import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChildren } from '@angular/core';
import { FormFieldComponent } from '../../components/form-field/form-field'
import { PhoneValidatorDirective } from '../../directives/phone-validator';
import { OrderDataService } from '../../services/order-data';
import { PersonModel } from '../../models/person-model';
import { EnrollmentType } from '../../pages/wizard-page/wizard-page';

@Component({
  selector: 'app-wz-step-account-mgmt',
  templateUrl: './wz-step-account-mgmt.html',
  styleUrls: ['./wz-step-account-mgmt.scss']
})

export class WzStepAccountMgmtComponent implements OnInit {

  readonly phonePlaceholder = PhoneValidatorDirective.readableFormat;
  readonly EnrollmentType = EnrollmentType;

  @Input() enrollmentType: EnrollmentType = EnrollmentType.SELF_MANAGE;
  @Input() partnerKey: string = null;
  @ViewChildren(FormFieldComponent) formFields: QueryList<FormFieldComponent>;
  @Output() clear = new EventEmitter();
  managedType = '';

  constructor(
    public orderData: OrderDataService) {
  }

  ngOnInit() {
  }

  onChange(formField) {
    if (formField && formField.name == 'ManagedType') {
      if (formField.data == 'Manager') {
        this.orderData.order.LeadManager = new PersonModel();
      } else {
        this.orderData.order.LeadManager = null;
      }
    }
  }

  onClear() {
    this.clear.emit(this.formFields);
  }
}
